import { Search } from "lucide-react";
import { LucideProps } from "lucide-react";

interface SearchIconProps extends LucideProps {
  className?: string;
}

export default function SearchIcon({ className = "", size = 20, ...props }: SearchIconProps) {
  return <Search className={className} size={size} {...props} />;
}
